import { render, staticRenderFns } from "./CopyrightAssignmentTransferFormsEscalated.vue?vue&type=template&id=18777138&scoped=true&"
import script from "./CopyrightAssignmentTransferFormsEscalated.vue?vue&type=script&lang=js&"
export * from "./CopyrightAssignmentTransferFormsEscalated.vue?vue&type=script&lang=js&"
import style0 from "./CopyrightAssignmentTransferFormsEscalated.vue?vue&type=style&index=0&id=18777138&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18777138",
  null
  
)

export default component.exports